<template>
    <div class="status-cell-wrapper">
        <div 
            class="status-cell-wrapper__dot" 
            :style="{ backgroundColor: color }"
        />
        <div>{{ title }}</div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ICellRendererParams } from 'ag-grid-community';

interface StatusCell extends ICellRendererParams {
    color: string,
}

@Component({})
export default class StatusCellComponent extends Vue {
    private params?: StatusCell;

    private get title(): string {
        return this.params.value;
    }

    private get color(): string | undefined {
        return this.params?.color;
    }
}
</script>

<style scoped lang="scss">
.status-cell-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}
</style>